import { Component, OnInit, ViewChild, Input, Output, EventEmitter, TemplateRef, OnDestroy } from '@angular/core';
import {ConfirmComponent, BaseControl, Const, SubForma} from '@app/shared/index';

import { LocalDataSource } from 'ng2-smart-table';
import { ToastrService } from 'ngx-toastr';
import { DefaultValuesFormService } from './shared/default-values.form.service';
import { DefaultValuesConfigService } from './shared/default-values.config.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'iw-default-values',
  templateUrl: './default-values.component.html',
  styleUrls: ['./default-values.component.scss'],
  providers: [
    DefaultValuesFormService
  ]
})
export class DefaultValuesComponent implements OnInit, OnDestroy {

  // forma
  @Input() form: SubForma;
  // Define la accion a realizar en el formulario
  actionForm = '';
  // Pregunta de la modal de confirmaciones
  question = '';
  // Define cuando mostrar la tabla principal o el formulario
  formOpen = false;
  // Define si el campo en accion es para editar o agregar
  campoEdit = true;
  // Configuracion de la tabla
  settings = {};
  // Datos para llenar la tabla
  sourceData: any = [];
  // Array que contiene los datos para el selector
  data: any = [];
  // Array que contiene los datos para la propiedad
  dataValuesDefault: any = [];
  // Contiene el campo seleccionado
  campoSelect: any;
  // Contiene los controles de el formulario de asociaciones
  controls: BaseControl<any>[] = [];
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia al componente de confirmación
  @ViewChild('confirm') private confirm: ConfirmComponent;
  // Referencia a la plantilla para el control basico ng-select para el formulario
  @ViewChild('ngSelectFormulario') ngSelectFormulario: TemplateRef<any>;

  @Output() refreshSeries: EventEmitter<any> = new EventEmitter();


  constructor(
    private dvfs: DefaultValuesFormService,
    private toastr: ToastrService,
    ) { }

  ngOnInit() {
    const configTable = new DefaultValuesConfigService();
    this.settings = configTable.settings;
    configTable.accion.subscribe((res: any) => {
      this.defineActionCondictions(res.action, res.data);
    });
    this.dataSelector();
    this.loadingDefaultValues();
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Cargar valores por defecto configurados
   *
   * @memberof DefaultValuesComponent
   */
  loadingDefaultValues() {
    if (this.form.estilo['valores_defecto']) {
      this.sourceData = this.form.estilo['valores_defecto'];
      this.dataValuesDefault = this.form.estilo['valores_defecto'];
    }
  }

  /**
   * Condiciona acción ha realzar
   *
   * @param {('add' | 'update' | 'delete')} [action='add']
   * @param {*} [data]
   * @memberof DefaultValuesComponent
   */
  defineActionCondictions(action: 'add' | 'update' | 'delete' = 'add', data?: any) {
    switch (action) {
      case 'add':
        this.formOpen = true;
        this.campoEdit = false;
        this.actionForm = 'Agregar';
        this.controls = this.dvfs.getFormDefaultValues(this.ngSelectFormulario);
        break;
      case 'update':
        this.formOpen = true;
        this.campoEdit = true;
        this.actionForm = 'Modificar';
        this.campoSelect = data;
        this.controls = this.dvfs.getFormDefaultValues(this.ngSelectFormulario, this.campoSelect);
        break;
      case 'delete':
        this.campoSelect = data;
        this.question = '¿Realmente desea eliminar el valor por defecto seleccionado?';
        this.confirm.open();
        break;
    }
  }

  /**
   * Cierra la vista del formulario de creacion o edicion
   *
   * @memberof DefaultValuesComponent
   */
  closeFormDefaultValues() {
    this.actionForm = '';
    this.question = '';
    this.formOpen = false;
    this.campoEdit = false;
    this.campoSelect = null;
  }

  /**
   * Seleccionar los campos excepto el que seleccionó en multiples registros
   *
   * @memberof DefaultValuesComponent
   */
  dataSelector() {
    if (this.form && this.form.campos) {
      for (let i = 0; i < this.form.campos.length; i++) {
        if (this.form.campos[i].id !== this.form.estilo['campo_multiple'] ) {
          const obj = {
            'id': this.form.campos[i].id,
            'tipo_campo': this.form.campos[i].tipo_campo.nombre,
            'alias': this.form.campos[i].alias
          };
          this.data.push(obj);
        }
      }
    }
  }

  /**
   * Guarda o edita un valor por defecto
   *
   * @param {*} data
   * @memberof SeriesDocumentaryComponent
   */
  sended(data: any) {
    if (data) {
      if (data.cboCampo && data.txtValorPorDefecto) {
        // Agregar
        if (!this.campoSelect) {
          const objData = {
            'campo': data.cboCampo,
            'valor': data.txtValorPorDefecto
          };
          this.dataValuesDefault.push(objData);
          this.form.estilo['valores_defecto'] = this.dataValuesDefault;
          this.toastr.success('Se agregó correctamente el valor por defecto', 'Operación exitosa');
        } else {
          // Editar
          for (let i = 0; i < this.form.estilo['valores_defecto'].length; i++) {
            if (this.campoSelect.campo === this.form.estilo['valores_defecto'][i].campo) {
              const objData = {
                'campo': data.cboCampo,
                'valor': data.txtValorPorDefecto
              };
              this.form.estilo['valores_defecto'][i] = objData;
              break;
            }
          }

          this.toastr.success('Se modificó correctamente el valor por defecto', 'Operación exitosa');

        }
      }
    }

    this.loadingDefaultValues();
    this.closeFormDefaultValues();

  }

  /**
   * Controla la accion de confirmar la eliminacion de un registro
   *
   * @param {boolean} res
   * @memberof DefaultValuesComponent
   */
  actionComfirm(res: boolean) {
    if (res) {
      this.delete();
    }
    this.question = '';
  }


  /**
   * Elimina un registro de la tabla de valores por defecto
   *
   * @private
   * @memberof DefaultValuesComponent
   */
  private delete() {
    const data: any = [];
    for (let i = 0; i < this.form.estilo['valores_defecto'].length; i++) {
      if (this.campoSelect.campo !== this.form.estilo['valores_defecto'][i].campo) {
        data.push(this.form.estilo['valores_defecto'][i]);
      }
    }
    this.form.estilo['valores_defecto'] = data;
    this.toastr.success('Se eliminó correctamente el valor por defecto', 'Operación exitosa');
    this.loadingDefaultValues();
  }
}





// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/creation-form/default-values/default-values.component.ts